// extracted by mini-css-extract-plugin
export default {"main":"App_main__nhgh3","page-container":"App_page-container__4pri6","main-container":"App_main-container__EPIb1","menu-btn":"App_menu-btn__6ap9C"};